// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"172":"1e1f1bd7","308":"4e9ae18f"}[chunkId] + ".chunk.css";
};